module.exports = __webpack_public_path__ + "static/media/bikes_hp.345e4ddb.jpg";